import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { useState, useEffect } from 'react';
import { USER_ROLES } from "../../interface/comman.constant";
import { useSelector } from "react-redux";

export function useUserSettings(reportName: string) {
  const userSettings = useSelector((state: any) => state?.auth?.userSettings) || {};

  return { id: userSettings?.id, dbColumnConfig: userSettings?.gridSettings?.[reportName] || {} };
}